class CardSwatches {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('card-swatch') && !event.target.classList.contains('card-swatch--unavailable') && !event.target.classList.contains('card-swatch--more')) {
        this.handleSwatchClick(event.target);
      }
    });
  }

  handleSwatchClick(swatchButton) {
    const productId = swatchButton.dataset.productId;
    const variantId = swatchButton.dataset.variantId;
    const variantImageUrl = swatchButton.dataset.variantImageUrl;
    const colorValue = swatchButton.dataset.colorValue;

    if (!productId) return;

    // Find the product card container
    const cardWrapper = swatchButton.closest('.card-wrapper');
    if (!cardWrapper) return;

    // Update the product image if we have a variant image URL
    if (variantImageUrl && variantImageUrl !== '') {
      this.updateProductImage(cardWrapper, variantImageUrl);
    }

    // Update selected state
    this.updateSelectedState(cardWrapper, colorValue);

    // Update product URL if variant ID is available
    if (variantId && variantId !== '') {
      this.updateProductUrl(cardWrapper, variantId);
    }
  }

  updateProductImage(cardWrapper, variantImageUrl) {
    const mediaContainer = cardWrapper.querySelector('.card__media .media');
    if (!mediaContainer) return;

    // Find the existing image
    const existingImage = mediaContainer.querySelector('img');
    if (!existingImage) return;

    // Create new image element with the same attributes as the original
    const newImage = document.createElement('img');
    newImage.className = existingImage.className;
    newImage.loading = existingImage.loading || 'lazy';
    newImage.alt = existingImage.alt;
    newImage.sizes = existingImage.sizes;

    // Use the provided variant image URL
    newImage.src = variantImageUrl;
    
    // Create srcset for responsive images
    const baseUrl = variantImageUrl.split('?')[0];
    const srcset = [
      `${baseUrl}?width=165 165w`,
      `${baseUrl}?width=360 360w`,
      `${baseUrl}?width=533 533w`,
      `${baseUrl}?width=720 720w`,
      `${baseUrl}?width=940 940w`,
      `${baseUrl}?width=1066 1066w`
    ].join(', ');
    
    newImage.srcset = srcset;

    // Position the new image absolutely on top of the old one
    newImage.style.position = 'absolute';
    newImage.style.top = '0';
    newImage.style.left = '0';
    newImage.style.width = '100%';
    newImage.style.height = '100%';
    newImage.style.objectFit = 'cover';
    newImage.style.opacity = '0';
    newImage.style.transition = 'opacity 0.3s ease';

    // Add the new image to the container
    mediaContainer.appendChild(newImage);

    // Crossfade effect
    newImage.onload = () => {
      // Fade in the new image
      requestAnimationFrame(() => {
        newImage.style.opacity = '1';
        
        // After transition, remove the old image
        setTimeout(() => {
          if (existingImage.parentNode) {
            existingImage.remove();
          }
          // Reset new image positioning
          newImage.style.position = '';
          newImage.style.top = '';
          newImage.style.left = '';
          newImage.style.width = '';
          newImage.style.height = '';
          newImage.style.objectFit = '';
        }, 300);
      });
    };

    // If the image is already cached, start transition immediately
    if (newImage.complete) {
      newImage.onload();
    }
  }

  updateSelectedState(cardWrapper, colorValue) {
    // Remove selected class from all swatches in this card
    const allSwatches = cardWrapper.querySelectorAll('.card-swatch');
    allSwatches.forEach(swatch => {
      swatch.classList.remove('card-swatch--selected');
    });

    // Add selected class to clicked swatch
    const clickedSwatch = cardWrapper.querySelector(`[data-color-value="${colorValue}"]`);
    if (clickedSwatch) {
      clickedSwatch.classList.add('card-swatch--selected');
    }
  }

  updateProductUrl(cardWrapper, variantId) {
    if (!variantId) return;
    
    // Get the product ID from any swatch in the card
    const productId = cardWrapper.querySelector('[data-product-id]')?.dataset.productId;
    if (!productId) return;
    
    // Find and update all product links in the card
    const allLinks = cardWrapper.querySelectorAll('a[href]');
    
    allLinks.forEach(link => {
      // Check if this link goes to the product (not external links, anchors, etc.)
      if (link.href && 
          (link.href.includes('/products/') || link.href.includes('product')) &&
          !link.href.includes('#') && 
          !link.href.includes('mailto:') && 
          !link.href.includes('tel:')) {
        
        try {
          const currentUrl = new URL(link.href);
          currentUrl.searchParams.set('variant', variantId);
          link.href = currentUrl.toString();
        } catch (e) {
          // Skip malformed URLs
          console.warn('Could not update URL:', link.href);
        }
      }
    });
    
    // Also update any data-product-url attributes (for quick-add buttons, etc.)
    const elementsWithProductUrl = cardWrapper.querySelectorAll('[data-product-url]');
    elementsWithProductUrl.forEach(element => {
      if (element.dataset.productUrl) {
        try {
          const currentUrl = new URL(element.dataset.productUrl);
          currentUrl.searchParams.set('variant', variantId);
          element.dataset.productUrl = currentUrl.toString();
        } catch (e) {
          // Skip malformed URLs
          console.warn('Could not update data-product-url:', element.dataset.productUrl);
        }
      }
    });
    
    // Store the current variant ID on the card wrapper for future reference
    cardWrapper.dataset.selectedVariantId = variantId;
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CardSwatches();
});

// Also initialize for dynamically loaded content
document.addEventListener('shopify:section:load', () => {
  new CardSwatches();
}); 